export default "__VITE_ASSET__857041c9__"